/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../../../root'
import { RcmTableDataWrapper } from '../../../rcm-table/RcmTableDataWrapper'
import { FavoritesDocsTable } from './FavoritesDocsTable'
import useDocumentsListService from '../../../../hooks/useDocumentsListService'

interface FavoritesDocsSectionProps {
  hidePaginate?: boolean
}

export const FavoritesDocsSection: React.FC<FavoritesDocsSectionProps> = ({ hidePaginate }) => {
  const {
    service: {
      filter: { translate }
    }
  } = useServiceContext()
  const { loadFavorites } = useDocumentsListService()

  const loadDataFavoritesDocs = (pagingParams: any, filter: any) => {
    const defaultFilter = {
      pageSize: pagingParams?.pageSize || 5,
      pageStart: pagingParams?.pageStart || 0,
      sortBy: pagingParams?.sortBy || 'lastModified',
      sortDesc: pagingParams?.sortDesc !== undefined ? pagingParams.sortDesc : true,
      ...filter
    }
    return loadFavorites(defaultFilter)
  }

  return (
    <>
      <h2 className="favorites">{translate('FAVORITES')}</h2>
      <RcmTableDataWrapper persistenceKey={'dashboardFavoritesFiles'} loadData={loadDataFavoritesDocs}>
        <FavoritesDocsTable hidePaginate={hidePaginate} />
      </RcmTableDataWrapper>
    </>
  )
}
